module.exports = __webpack_public_path__ + "static/img/landing2_05_downloadBtn.a056a08.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/landing/landing2_05_downloadBtn.webp
// module id = YJa1
// module chunks = 0